package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.{GetTestDetailData, GetTestDetailMessage, MessageType, SendMessageAdapter, SequenceElement, SequenceStatus, SessionData, SessionState, StateData, Test, TestPackageData, TestRunDetail, TestStatus}

import scala.collection.mutable.ArrayBuffer
import io.circe.generic.auto._
import com.neurobs.ccab.MessageData._
import com.neurobs.js.view.Gui

import scala.collection.mutable

case class Session(data: SessionData, state: SessionState) {

	val stopped = state.stopped
	val sequenceStatus = state.sequenceStatus
	val sequence = state.seq

	def testName(i: Int): String = data.group.tests(i).name
}

class ControllerState(val testRunCache: TestRunDetailCache) {
	private var packageData: Option[TestPackageData] = None
	private var lastSession: Option[SessionData] = None
	private var lastState: Option[StateData] = None
	//private val logs: ArrayBuffer[Option[TestRunDetail]] = ArrayBuffer()

	private implicit def optToBool(opt: Option[_]): Boolean = opt.isDefined

	def setTestPackage(data: TestPackageData): Boolean = {
		if (packageData.isEmpty) {
			packageData = Some(data)
			true
		} else false
	}

	def setSessionData(data: SessionData): Boolean = {
		val newSession = for {
			state <- lastState
			sessionState <- state.session
			if sessionState.session_id == data.session_id
			if lastSession.forall(_.session_id != data.session_id)
		} yield data

		newSession match {
			case Some(s) => lastSession = newSession; true
			case None => false
		}
	}

	case class Changes(newRun: Boolean)
	def setState(state: StateData, sender: SendMessageAdapter): Changes = {
		val newRun = for {
			newSession <- state.session
			ls <- lastState
			oldSession <- ls.session
		} yield {
			val hasNew = newSession.log.length > oldSession.log.length
			// If the next test runs immediately, the final state of the previous
			// test may not have been sent in a state update, so invalidate the cache
			// if necessary
			oldSession.last_log.foreach(last =>
				if (last.status != TestStatus.Finished) {
					testRunCache.invalidate(oldSession.log.length - 1)
				}
			)
			hasNew
		}

		lastState = Some(state)
		lastSession = for {
			sessionState <- state.session
			session <- lastSession
			if session.session_id == sessionState.session_id
		} yield session
		if (state.session && lastSession.isEmpty) sender.send(MessageType.GetSessionData)
		if (!state.session) testRunCache.clear()
		else for {
			s <- state.session
			l <- s.last_log
		} testRunCache.set(s.log.length - 1, l)
		Changes(newRun.getOrElse(false))
	}

	def state: Option[StateData] = lastState

	def showSessionSelect: Boolean = lastState && (!lastState.get.session) && packageData

	def getPackageData: Option[TestPackageData] = packageData

	def getRunsOfSequenceItem(id: SequenceElement.Id): Seq[Option[TestRunDetailInstance]] = {
		session match {
			case None => List()
			case Some(s) => s.state.log.view.zipWithIndex.filter(_._1.seq_id == Some(id)) map { log =>
				testRunCache.get(log._2)
			}
		}
	}

	def showSession: Boolean = lastState && lastState.get.session && lastSession

	def stopped: Boolean = state.flatMap(_.session.map(_.stopped)).getOrElse(true)

	def sequenceStatus: Option[SequenceStatus.Value] = state.flatMap(_.session.map(_.sequenceStatus))

	def session: Option[Session] = for {
		state <- lastState
		sstate <- state.session
		data <- lastSession
	} yield Session(data, sstate)

	def testIndex(t: Test): Option[Int] = {
		lastSession.flatMap { s =>
			s.group.tests.indexWhere(_ eq t) match {
				case -1 => None
				case i => Some(i)
			}
		}
	}
}
